export default "__VITE_ASSET__CDKFQW57__"